import axios from 'axios';
import { getApiBaseUrl } from '../../config/api';
import {
    getRequest,
    getSuccess,
    getFailed,
    getError,
    stuffDone
} from './studentSlice';

export const getAllStudents = (id) => async (dispatch) => {
    dispatch(getRequest());

    try {
        const result = await axios.get(`${getApiBaseUrl()}/Students/${id}`);
        if (result.data.message) {
            dispatch(getFailed(result.data.message));
        } else {
            dispatch(getSuccess(result.data));
        }
    } catch (error) {
        dispatch(getError(error));
    }
}

export const updateStudentFields = (id, fields, address) => async (dispatch) => {
    dispatch(getRequest());

    try {
        const result = await axios.put(`${getApiBaseUrl()}/${address}/${id}`, fields, {
            headers: { 'Content-Type': 'application/json' },
        });
        if (result.data?.message && !result.data?.id && !result.data?._id) {
            dispatch(getFailed(result.data.message));
            return { success: false, message: result.data.message };
        }
        dispatch(stuffDone());
        return { success: true, data: result.data };
    } catch (error) {
        dispatch(getError(error));
        const msg = error.response?.data?.message || error.message || 'Could not update student';
        return { success: false, message: msg };
    }
}

export const removeStuff = (id, address) => async (dispatch) => {
    dispatch(getRequest());

    try {
        const result = await axios.put(`${getApiBaseUrl()}/${address}/${id}`);
        if (result.data.message) {
            dispatch(getFailed(result.data.message));
        } else {
            dispatch(stuffDone());
        }
    } catch (error) {
        dispatch(getError(error));
    }
}